import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import moment from 'moment';

import { Numeric } from 'components';
import { useProtectedClient, useReleases } from 'hooks';
import { getReadablePlanType } from 'helpers';
import ClientBillingReportRow from './ClientBillingReportRow';

const Settings: FC = () => {
  const { t } = useTranslation();
  const client = useProtectedClient();
  const readablePlanType = getReadablePlanType(client.feature_plan_type);
  const releases = useReleases();

  function renderTopRow() {
    return (
      <Grid container item spacing={3}>
        <Grid item xs={4}>
          <Typography variant="overline" color="textSecondary">
            {t('admin:workspaceName')}
          </Typography>
          <Typography noWrap variant="subtitle2">
            {client.title}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="overline" color="textSecondary">
            {t('admin:workspaceType')}
          </Typography>
          <Typography noWrap variant="subtitle2">
            {readablePlanType}
          </Typography>
        </Grid>
        {client.billing?.billable_user_count && (
          <Grid item xs={4}>
            <Typography variant="overline" color="textSecondary">
              {t('admin:workspaceActiveUsers')}
            </Typography>
            <Typography variant="subtitle2">
              <Numeric value={client.billing.billable_user_count} />
            </Typography>
          </Grid>
        )}
      </Grid>
    );
  }

  function renderMiddleRow() {
    return (
      <Grid container item spacing={3}>
        <Grid item xs={4}>
          <Typography variant="overline" color="textSecondary">
            {t('admin:workspaceDomain')}
          </Typography>
          <Typography noWrap variant="subtitle2">
            {client.subdomain}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="overline" color="textSecondary">
            {t('admin:workspaceEmailAddress')}
          </Typography>
          <Typography noWrap variant="subtitle2">
            {client.email_address}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="overline" color="textSecondary">
            {t('admin:workspaceAccountCreated')}
          </Typography>
          <Typography noWrap variant="subtitle2">
            {moment.unix(client.created_at).format('ll')}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Fragment>
      <Grid container direction="column" spacing={3}>
        {renderTopRow()}
        {renderMiddleRow()}
        {releases.includes('activeUserDefinition') && <ClientBillingReportRow />}
      </Grid>
    </Fragment>
  );
};

export default Settings;
